import React from "react";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { useTheme } from "styled-components";
import FreeTextModalAndTrigger from "features/tradingTerminal/FreeText/FreeTextModalAndTrigger";
import Col from "antd/es/col";
import Row from "antd/es/row";
import Text from "common/Typography/Text";
import Flex from "common/Boxes/Flex";
import styled from "styled-components";
import { FixMeLater } from "types";
import useGeneral from "features/tradingTerminal/General/useGeneral";

const MiniGeneralTradeInfo = () => {
  const appTheme = useTheme();
  const {
    longShort,
    leverage,
    cancelOnTp,
    tradeType,
    quantityInput,
    amountInput,
    accountSelector,
    accountError,
    symbolSelector,
    symbolError,
    onExistingQuantityClick,
    amountCoin,
    quantityCoin,
    isLoading,
    confirmModalContextHolder,
    hasError,
    showGeneralOptions,
  } = useGeneral();

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ marginBottom: hasError ? 4 : 8, flex: "0 0 auto" }}>
        <AccountSymbolWrapper>
          {accountSelector}
          {symbolSelector}
        </AccountSymbolWrapper>
        {!isLoading && (
          <>
            {accountError}
            {symbolError}
          </>
        )}
      </div>
      <LoadingSpinnerOverlay
        isLoading={isLoading}
        wrap={true}
        backgroundColor={appTheme.colors.cardBgColor}
        wrapStyle={{
          flex: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          {showGeneralOptions && (
            <Flex>
              <MarginWrapper>
                {longShort}
                {leverage?.marginTypeSelector}
                {leverage?.multiplierSelector}
              </MarginWrapper>
              <div>{tradeType}</div>
            </Flex>
          )}
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={12}>
              <AmountCoinTitle>
                <AmountTitle>New Amount</AmountTitle>
                <span>{amountCoin}</span>
              </AmountCoinTitle>
              <AmountInputWrapper>{amountInput}</AmountInputWrapper>
            </Col>
            <Col span={12}>
              <AmountInputWrapper
                onClick={onExistingQuantityClick as FixMeLater}
              >
                <AmountCoinTitle>
                  <AmountTitle>Existing Amount</AmountTitle>
                  <span>{quantityCoin}</span>
                </AmountCoinTitle>
                {quantityInput}
              </AmountInputWrapper>
            </Col>
          </Row>
          {showGeneralOptions && (
            <div style={{ padding: hasError ? "6px 0" : "10px 0" }}>
              {cancelOnTp}
            </div>
          )}
        </div>
        <div>
          <FreeTextModalAndTrigger
            style={{
              padding: hasError
                ? showGeneralOptions
                  ? "6px 0"
                  : "16px 0"
                : "10px 0px",
            }}
          />
        </div>
      </LoadingSpinnerOverlay>
      {confirmModalContextHolder}
    </div>
  );
};

export default MiniGeneralTradeInfo;

const AmountInputWrapper = styled.div<{ onClick?: () => void }>`
  ${(p) =>
    p.onClick &&
    `
    &:after {
      opacity: 0.6;
      content: "";
      display: block;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: ${p.theme.colors.cardBgColor};
      cursor: pointer;
    }
  `}
`;
const AccountSymbolWrapper = styled(Flex)`
  grid-gap: 8px;
`;
const AmountCoinTitle = styled(Text).attrs({ as: "div" })`
  display: flex;
  justify-content: space-between;
  ${(p) =>
    p.theme.isNewLook &&
    `
    font-size: 13px;
    font-weight: ${p.theme.typography.fontWeights.MEDIUM};
    color: ${p.theme.colors.primaryText};
    margin-bottom: 4px;
    > span:last-child {
      color: ${p.theme.colors.secondaryText};
    }
  `}
`;
const AmountTitle = styled.span`
  margin-bottom: 4px;
`;
const MarginWrapper = styled(Flex)`
  grid-gap: 8px;
`;
